import { Bot, Search, Package, Mail, Truck } from 'lucide-react';
import Card from '@/components/ui/Card';

interface Props {
  onSkip: () => void;
}

const CAPABILITIES = [
  {
    icon: Search,
    title: 'Discover Suppliers',
    description: "I search brand programs, Alibaba/1688, and wholesale distributors to find free-to-list dropship partners for your categories.",
  },
  {
    icon: Mail,
    title: 'Negotiate Samples',
    description: "I draft and send sample requests, follow up when suppliers go quiet, and track every conversation so nothing falls through.",
  },
  {
    icon: Package,
    title: 'List Products',
    description: "I generate product descriptions, images, categorize listings, and stage drafts for your review — on-brand from day one.",
  },
  {
    icon: Truck,
    title: 'Fulfill Orders',
    description: "When orders arrive, I forward them to the right supplier, check inventory, and coordinate returns without your involvement.",
  },
];

export default function WelcomeStep1MeetDippy({ onSkip }: Props) {
  return (
    <div className="space-y-6">
      <Card className="text-center py-10 px-6 bg-gradient-to-b from-sage-50 to-white">
        <div className="mx-auto mb-5 w-20 h-20 rounded-full bg-sage-100 flex items-center justify-center">
          <Bot className="w-12 h-12 text-sage-700" />
        </div>
        <h2 className="text-2xl font-display font-bold text-text-primary mb-2">
          Meet Dippy
        </h2>
        <p className="text-text-secondary max-w-md mx-auto">
          Your AI dropship partner. Dippy finds suppliers, negotiates samples, lists products, and handles orders so you can focus on growing the store.
        </p>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {CAPABILITIES.map((cap) => (
          <Card key={cap.title} className="p-5">
            <div className="flex items-start gap-3">
              <div className="shrink-0 w-10 h-10 rounded-lg bg-sage-100 flex items-center justify-center">
                <cap.icon className="w-5 h-5 text-sage-700" />
              </div>
              <div>
                <h3 className="font-semibold text-text-primary mb-1">{cap.title}</h3>
                <p className="text-sm text-text-secondary leading-relaxed">{cap.description}</p>
              </div>
            </div>
          </Card>
        ))}
      </div>

      <div className="text-center pt-2">
        <button
          type="button"
          onClick={onSkip}
          className="text-sm text-text-muted hover:text-text-secondary underline underline-offset-2"
        >
          Skip for now — I'll set up Dippy later
        </button>
      </div>
    </div>
  );
}
